import rx from "./_rx";
function initphotSwipe(selector) {
    this.$nextTick().then(() => {
        let arr = [];
        let arr2 = [];
        let imgs = document.querySelectorAll(selector);


        for (let i = 0; i < imgs.length; i++) {
            let p = new Promise((resolve) => {
                loadImg(imgs[i].src, i).then(obj => {
                    arr[obj.i] = { src: obj.src, w: obj.w, h: obj.h };
                    resolve();
                });
            });
            arr2.push(p);
        }
        Promise.all(arr2).then(() => {
            emitPhotoSwipe(imgs, arr);
        });

    });
}
function loadImg(src, i) {
    let count = 0;
    return load();
    function load() {
        let img = new Image();
        img.src = src;
        return new Promise((resolve, reject) => {
            count++;
            img.onload = function () {
                resolve({ i, src, w: img.width, h: img.height });
            }
            img.onerror = reject;
        }).catch(() => {
            if (count >= 3) {
                return Promise.resolve();
            }
            return load();
        });
    }
}
function emitPhotoSwipe(imgs, arr, index = 0) {
    for (let i = 0; i < imgs.length; i++) {
        imgs[i].addEventListener("click", function () {
            arr.forEach((item, i) => {
                if (this.src == item.src) {
                    index = i;
                    rx.emit("photoSwipe", { images: arr, index });
                    return;
                }
            });
        });
    }
}

export { initphotSwipe }